(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["como-dominar-la-contratacion-en-multiples-sucursales"] = factory();
	else
		root["como-dominar-la-contratacion-en-multiples-sucursales"] = factory();
})(this, function() {
return 